let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("rYVJw")).then(() => parcelRequire('lstlq'));